import { useState, memo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import AuthWrapper from '../components/authWrapper';
import Field from '@/components/formFields/InputField/Field';
import ActionBtn from '@/components/ActionBtn';


const ForgetPassForm = ({ onSubmit }) => {

    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()

   

    return (

        <AuthWrapper>
            <div className='inputsContainer'>
                    <Field className='col-md-12' lang='any' value={email} setValue={setEmail} placeholder={t("Email")} label={t("Email")} type="text" name="email" />
            </div>
            <ActionBtn isDisabled={loading} className={"login-btn"} onApply={e => onSubmit(e, { email, setLoading })} title={"Send Code"} />

            <div className='donot-have-account-container'>
                {t("backTo")} <Link to='/auth/log-in'>{t("login")}</Link>
            </div>
        </AuthWrapper>

    );
}

export default memo(ForgetPassForm);

